import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Card, IconButton, Stack, Typography } from '@mui/material';

import { FilterFlag } from '../filter-flag.type';

interface UsDiplomaFilterProps {
  value: FilterFlag;
  onChange: (hasUsDiploma: FilterFlag) => void;
  onDiscard: () => void;
}

export const UsDiplomaFilter = ({ onDiscard }: UsDiplomaFilterProps) => {
  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <Stack direction="row">
        <Typography variant="h6" mb={2}>
          US Diploma Year
        </Typography>
        <Box flex={1} />
        <IconButton aria-label="discard" onClick={onDiscard}>
          <DeleteIcon />
        </IconButton>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <CheckIcon />
        <Typography pt={'5px'}>US Diploma year offered</Typography>
      </Stack>
    </Card>
  );
};
